export const GET_SAVED_CAMPAIGNS = 'GET_SAVED_CAMPAIGNS';
export const GET_SAVED_CAMPAIGNS_SUCCESS = 'GET_SAVED_CAMPAIGNS_SUCCESS';
export const GET_SAVED_CAMPAIGNS_FAILED = 'GET_SAVED_CAMPAIGNS_FAILED';
